import Component from './ComponentText';
import customtrait from './customtraits';

export default Component.extend(
  {
    defaults: {
      ...Component.prototype.defaults,
      tagName: 'label',
      traits: [
        customtrait.bindable,
        customtrait.datasource,
        customtrait.fieldname,
        customtrait.datatype,
        customtrait.actionable,
        customtrait.eventName,
        customtrait.font_property,
        customtrait.font_title,
        customtrait.bg_property,
        customtrait.bg_title
      ]
    }
  },
  {
    isComponent(el) {
      if (el.tagName == 'LABEL') {
        return { type: 'label' };
      }
    }
  }
);
